export enum ClientErrorSource {
    ErrorBoundary = 1,
    WindowOnError = 2,
    UnhandledRejection = 3,
}

export const ClientErrorSourceLabels = [
    { id: ClientErrorSource.ErrorBoundary, name: 'Error Boundary' },
    { id: ClientErrorSource.WindowOnError, name: 'Window Error' },
    { id: ClientErrorSource.UnhandledRejection, name: 'Unhandled Rejection' },
];
